import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
//import { useTheme } from '@emotion/react';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
});

export default function FinalAssessment() {
  const theme = useTheme()
  const classes = styles(theme);
  
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <Typography color="textPrimary" variant="h5" align='center'>
        Final Assessment
      </Typography>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label="Group 1" {...a11yProps(0)} />
          <Tab label="Group 2" {...a11yProps(1)} />
          <Tab label="Group 3" {...a11yProps(2)} />
          <Tab label="Group 4" {...a11yProps(3)} />
          <Tab label="Group 5" {...a11yProps(4)} />
          <Tab label="Group 6" {...a11yProps(5)} />
          <Tab label="Group 7" {...a11yProps(6)} />
          <Tab label="Group 8" {...a11yProps(7)} />
          <Tab label="Group 9" {...a11yProps(7)} />
          <Tab label="Group 10" {...a11yProps(7)} />
          <Tab label="Group 11" {...a11yProps(7)} />


        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        Details for group 1
      </TabPanel>
      <TabPanel value={value} index={1}>
        Details for group 2
      </TabPanel>
      <TabPanel value={value} index={2}>
        Details for group 3
      </TabPanel>
      <TabPanel value={value} index={3}>
        Details for group 4
      </TabPanel>
      <TabPanel value={value} index={4}>
        Details for group 5
      </TabPanel>
      <TabPanel value={value} index={5}>
        Details for group 6
      </TabPanel>
      <TabPanel value={value} index={6}>
        Details for group 7
      </TabPanel>
      <TabPanel value={value} index={7}>
        Details for group 8
      </TabPanel>
      <TabPanel value={value} index={8}>
        Details for group 9
      </TabPanel>
      <TabPanel value={value} index={9}>
        Details for group 10
      </TabPanel>
      <TabPanel value={value} index={10}>
        Details for group 11
      </TabPanel>
    </div>
  );
}